module.exports = __webpack_public_path__ + "img/visorSuit.8efeff66.svg";